export default class VersionViewer {
    constructor(version) {
        this.version = version || '-.-.-';
    }
    init() {
        this.element = document.createElement('div');
        this.element.innerText = this.version;
        this.element.classList.add('version-panel');
        document.body.appendChild(this.element);
        this.setStyles();
    }
    setStyles() {
        const style = document.createElement('style');
        style.innerHTML = `
            .version-panel {
                position: absolute;
                right: 5px;
                bottom: 2px;

                opacity: 0.1;
                font-size: 12px;
                color: #222222;

                transition: opacity 0.15s ease-in-out;
                user-select: none;
            }

            .version-panel:hover {
                opacity: 1;
            }
        `;
        document.head.appendChild(style);
    }
}
